module.exports = __webpack_public_path__ + "static/media/orthodoxy-2.6d72b727.jpg";